import { render, staticRenderFns } from "./ChatInitiatorTemplate.vue?vue&type=template&id=c6f699b8&scoped=true"
import script from "./ChatInitiatorTemplate.vue?vue&type=script&lang=js"
export * from "./ChatInitiatorTemplate.vue?vue&type=script&lang=js"
import style0 from "./ChatInitiatorTemplate.vue?vue&type=style&index=0&id=c6f699b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f699b8",
  null
  
)

export default component.exports